
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import HelloTongCard from './card/helloTongCard.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import type { HomeworkOption, DairyOption } from '@xt/client/entities/course-v2/user-content'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    HelloTongCard,
    NewSwiper,
    UserContentPop,
    Qrcode,
    LazyImg
  }
})
export default class extends Vue {
  @Ref()
  helloTong: HTMLDivElement

  @Ref()
  swiper: {
    startScroll: () => void
    stopScroll: () => void
    hanldeScrollTo: (index: number) => void
  }

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  ob: IntersectionObserver | null = null

  showTabs: boolean = false

  activeIndex: number = 0

  tabIndex: number = 0

  needLogin = false

  allList = []

  firstIndex = {}

  get dataSource() {
    return this.$store.$homeV2.dataSource?.userContent
  }

  handleClickMore() {
    window.open(`/kindred-spirit`)
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  stopScroll() {
    if (!this.swiper) return

    this.swiper.stopScroll()
  }

  startScroll() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
      return
    }

    if (!this.swiper) return

    this.swiper.startScroll()
  }

  handleOpenContent(id: string) {
    if (!id) return

    this.userContentPop?.showPop({
      type: 'dairy',
      momentId: id
    })

    // 打开弹窗，滚动列表抖动
    setTimeout(() => {
      this.swiper.stopScroll()
    }, 0)
  }

  formatData() {
    let length = 0

    if (!this.dataSource) return

    this.dataSource.forEach((el: any) => {
      this.allList = this.allList.concat(...el.list)

      this.firstIndex[el.key] = length

      length = length + el.list.length
    })
  }

  changeItem(index: number) {
    const data: [string, number][] = Object.entries(this.firstIndex)

    const sortedEntries: [string, number][] = data.sort((a: [string, number], b: [string, number]) => b[1] - a[1])

    for (const [key, value] of sortedEntries) {
      if (index >= value) {
        this.tabIndex = parseInt(key)
        return
      }
    }

    this.tabIndex = 0
  }

  changeTab(index) {
    this.tabIndex = index

    this.swiper.hanldeScrollTo(this.firstIndex[index])
  }

  created(): void {}

  mounted(): void {
    this.formatData()

    if (!this.helloTong || !window.IntersectionObserver) {
      this.showTabs = true
      return
    }

    this.ob = new IntersectionObserver(
      entity => {
        this.showTabs = entity[0].isIntersecting
      },
      {
        threshold: [0, 1]
      }
    )

    this.ob.observe(this.helloTong)
  }

  updated(): void {}

  destroyed(): void {
    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
